import { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useIndeedPanelParams } from '@/hooks/use-indeed-panel-params';
import { useIndeedSettings } from '@/hooks/use-indeed-settings';
import { useSourceIndeedContract } from '@/hooks/use-source-indeed-contract';

import { ConnectMode } from './connect-mode';
import { ConfigureMode } from './configure-mode';
import { Loader } from '../contract-form/loader';

export function IndeedPanelHost() {
  const enabled = useSourceIndeedContract();
  const { isOpen, isOrganic, close } = useIndeedPanelParams();
  if (!enabled || !isOpen) return null;

  return (
    <Sheet open onOpenChange={open => !open && close()}>
      <SheetContent
        side="right"
        className="flex min-h-0 w-full flex-col !gap-0 overflow-hidden sm:min-w-[550px]"
        aria-describedby={undefined}
      >
        <Suspense
          fallback={
            <>
              <SheetHeader>
                <SheetTitle>
                  <FormattedMessage
                    defaultMessage="Add Contract"
                    description="Sheet title: Add a new contract"
                  />
                </SheetTitle>
              </SheetHeader>
              <Loader />
            </>
          }
        >
          <IndeedPanelContent isOrganic={isOrganic} onClose={close} />
        </Suspense>
      </SheetContent>
    </Sheet>
  );
}

function IndeedPanelContent({
  isOrganic,
  onClose,
}: {
  isOrganic: boolean;
  onClose: () => void;
}) {
  const { data: settings } = useIndeedSettings();
  if (settings.indeed_authorized)
    return (
      <ConfigureMode
        settings={settings}
        isOrganic={isOrganic}
        onClose={onClose}
      />
    );
  return (
    <ConnectMode settings={settings} isOrganic={isOrganic} onClose={onClose} />
  );
}
